<template>
<div class="chapter">
<div class="inner_page">
<p class="h2c"><a id="page_vi"></a><a id="page_vii"></a>Acknowledgments</p>
<p class="noindent">This book is the summary of work that has occupied me for over a decade.<sup><span href="#/xhtml/9780226066295_34_Notes#ifm1en1" id="fm1en1" title="Link target outside of Sample">1</span></sup> I have received help from many people. From John Winnie I have learned to appreciate the power of the natural sciences. Henry Bugbee taught me to affirm in my thinking what matters to me in life. Carl Mitcham’s friendship has been crucial to my working out a philosophy of technology. The staff, the faculty, and the administration of the University of Montana have supported my work generously. Finally, I am indebted to discussions with my students.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226066295_04_Ack.vue?54ce0722